import { SaveButton, RemoveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field, reduxForm } from "redux-form"
import validate from "./businessUnitFormValidation"


let BusinessUnitForm = props => {
    const { handleSubmit, loading, initialValues } = props

    return (
        <form onSubmit={handleSubmit}>
            <Row className="form-group mt-3">
                <Col>
                    <Field
                        name={"name"}
                        label={"Name"}
                        component={TextField}
                    />
                </Col>
            </Row>

            <Row className="form-group mt-3">
                <Col>
                    <SaveButton content={initialValues && initialValues.id ? "Update" : "Add"} loading={loading} />
                </Col>
            </Row>
        </form>
    )
}

BusinessUnitForm = reduxForm({
    form: FORM_NAMES.BUSINESS_UNIT, // must be unique
    validate,
})(BusinessUnitForm)

export default BusinessUnitForm;